/**
 * NotificationBell — thin wrapper around the existing PushToggle so the
 * Header stays declarative and future notification-count / drawer
 * features live here without touching Header.jsx.
 */
import PushToggle from "@/components/PushToggle";

export default function NotificationBell() {
  return (
    <div className="flex-none" data-testid="notification-bell">
      <PushToggle />
    </div>
  );
}
